// @flow
import { CHANGE_TITLE, CHANGE_DESCRIPTION } from './constants';
import type { State, Action, LocalizedValue } from './types';

const defaultTitle: LocalizedValue = {
  IN: {
    en: 'We find your affordable healthcare for you! - Yapita Health'
  }
};

const defaultDescription: LocalizedValue = {
  IN: {
    en: 'We take the stress out of finding the best and affordable healthcare for you!'
  }
};

const defaultState: State = {
  title: defaultTitle,
  description: defaultDescription
};

export default (state: State = defaultState, action: Action): State => {
  switch (action.type) {
    case CHANGE_TITLE:
      return { ...state, title: action.localizedValue || defaultTitle };
    case CHANGE_DESCRIPTION:
      return { ...state, description: action.localizedValue || defaultDescription };
    default:
      return state;
  }
};
